import React from 'react';
import { SignInLayoutV2 } from './SignInLayoutV2';
import SecondScreen from './SecondScreen';

export const SignInLayout = (props) => {
  const { isDeviceActivation } = props;

  if (isDeviceActivation) {
    return <SecondScreen {...props} />;
  }
  return <SignInLayoutV2 {...props} />;
};
